import React from 'react'
import './events-line.css'
import LineGraph from './LineGraph'


const legends = (a) => {
    let legend = []
    a.forEach(d => {
        legend.push(d.label)
    });
    return legend
}

const valueIten = (a) => {
    let iten = []
    a.forEach(d => {
        iten.push(d.value)
    });
    return iten
}

const EventsLine = props => {
    // console.log(props.data)
    const data = [
        { label: props.data.totalEvent[1].label, value: props.data.totalEvent[1].value, color: 'red' },
        { label: props.data.totalEvent[0].label, value: props.data.totalEvent[0].value, color: 'orange' },
        { label: props.data.totalEvent[2].label, value: props.data.totalEvent[2].value, color: '#bfbfbf' },
    ]

    const dataLine = {
        labels: legends(props.data.listEvent[0].listData),
        datasets: [
            {
                label: props.data.listEvent[1].title,
                data: valueIten(props.data.listEvent[1].listData),
                fill: false,
                backgroundColor: '#ff0000',
                borderColor: '#ff0000',
            },
            {
                label: props.data.listEvent[0].title,
                data: valueIten(props.data.listEvent[0].listData),
                fill: false,
                backgroundColor: '#ffa500',
                borderColor: '#ffa500',
            },
            {
                label: props.data.listEvent[2].title,
                data: valueIten(props.data.listEvent[2].listData),
                fill: false,
                backgroundColor: '#bfbfbf',
                borderColor: '#bfbfbf',
            },
        ],
    }

    return (
        <div className='events-line-container'>
            <span className='events-line-title '>Eventos Realizados</span>

            <div className='events-line-content'>
                <div style={{ width: '590px', height: '320px' }}>
                    <LineGraph data={props.laoding ? {} : dataLine} />
                </div>

                <div className='fake-legend-content'>
                    {data.map((d, i) => {
                        return (
                            <div className='fake-legend-iten' key={i}>
                                <div className='fake-legend-box' style={{ backgroundColor: d.color }} />
                                <span className='fake-legend-title'>{`${d.value} ${d.label}`}</span>
                            </div>
                        )
                    })}

                </div>

            </div>
        </div>
    )
}

export default EventsLine